module.exports = __webpack_public_path__ + "img/Rectangle 23.eb4eeb19.png";